import { maskValue } from '@/base/directives/mask.directive'
import { BLIK_CODE_LENGTH, BLIK_CODE_MASK } from '@/base/const/blik.const'

// Kod z mBanku bywa kopiowany ze spacją niełamliwą (U+00A0) zamiast zwykłej, a z innych aplikacji
// z innymi znakami niewidocznymi lub z tekstem wokół. Walidator przyjmuje tylko cyfry i zwykłą spację,
// więc wszystko inne wycinamy, zanim wartość trafi do magazynu i do vee-validate (PEP-1418).
// Nie polegamy na masce `v-mask`: jej listener działa PO handlerze `@input` pola, więc handler
// i tak dostaje wartość surową.
export function extractBlikDigits(value) {
  if (typeof value !== 'string') return ''
  return value.replace(/\D/g, '').slice(0, BLIK_CODE_LENGTH)
}

// zapis `### ###` — ten sam formatter, którego używa maska pola
export function formatBlikCode(value) {
  return maskValue(extractBlikDigits(value), BLIK_CODE_MASK)
}
